<template>
  <v-menu offset-y top :close-on-content-click="false" v-model="open">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" v-on="on">Batch edit</v-btn>
    </template>
    <v-card flat width="350">
      <v-card-title>Batch edit</v-card-title>
      <v-card-subtitle>Only checked fields will be updated</v-card-subtitle>
      <v-card-text class="pa-0">
        <v-container class="pt-0 px-6">
          <v-row>
            <v-col cols="2">
              <v-checkbox v-model="input.updateActive"/>
            </v-col>
            <v-col cols="2">
              <v-checkbox label="Active" v-model="input.active" hide-detlails :disabled="!input.updateActive"/>
            </v-col>
          </v-row>
        </v-container>
        <v-divider/>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="open=false">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>

export default {
  name: 'EquipmentOtherBatchEdit',
  props: {
    equipment: {type:Array, required:true}
  },
  data() {
    return {
      open: false,
      input: {updateActive: false,
              active:true,
              otherEquipment:[]},
      accounts: [],
      saving: false
    }
  },
  methods: {
    async save() {
      this.saving = true;
      this.input.otherEquipment = this.equipment.map(e => e.id);
      const results = await this.$apiCall(`mutation EquipmentOtherBatchEdit($input: OtherEquipmentBatchUpdateInput!) {
                                              otherEquipmentsBatchUpdate(input:$input) {id,error}
                                            }`,
                                          {input:this.input});
      this.saving = false;
      if (!results.error) {
        this.open = false;
        const errorCount = results.data.otherEquipmentsBatchUpdate.length;
        this.$store.commit('setError', {type:errorCount ? 'warning' : 'success',
                                        message:`Updated ${this.equipment.length - errorCount} of ${this.equipment.length} other equipment\
                                                  ${errorCount ? `(${errorCount} error${errorCount > 1 ? 's':''})` : ``}`});
        this.$emit('refresh', results.data.otherEquipmentsBatchUpdate);
      }
    }
  }
}
</script>